import { useBreakpoints, breakpointsTailwind } from '@vueuse/core'

export function useDeviceType() {
  const breakpoints = useBreakpoints(breakpointsTailwind)
  const isDesktop = breakpoints.greaterOrEqual('lg')

  return { isDesktop }
}
